export default {
    mortgageCalculator: 'mortgageCalculator',
    mortgageRates: 'mortgageRates',
    mortgageRefinance: 'mortgageRefinance',
    preapproval: 'preapproval',
    buyingPower: 'buyingPower',
    sellers: 'sellers',
    agents: 'agents',
    bonus: 'bonus',
    homeworth: 'homeworth',
    bonus_AAA: 'bonus_AAA',
    mortgage: 'mortgage',
    genericFAQs: 'genericFAQs'
};